import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import { setPreviousFinanceInputWithoutFFB } from '../actions/creators';
import * as types from '../types/actionTypes';
import { isFlexBuyPayment } from '../selectors';

export const updatedPenciledInputsMiddleware = (store: any) => (next: any) => (action: AnyFSA) => {
    next(action);
    const state = store.getState();
    const isFlexBuy = isFlexBuyPayment(state);

    if ([types.INIT_SUCCESS, types.PAYMENT_RECEIVED].includes(action.type) && !isFlexBuy) {
        store.dispatch(setPreviousFinanceInputWithoutFFB());
    }
};
